import RenderCanvas from './renderCanvas.js'
import EditorCanvas from './editorCanvas.js'
import { nanoid } from 'nanoid'
import { defaultBackgroundStore } from '@/store/defaultBackgroundStore'

// core 继承renderCanvas 包含editorCanvas , renderCanvas继承renderWasm
export default class Editor extends RenderCanvas {
	#_randerCanvasId = null
	static #_cache = null
	#_loadCallBackList = []
	#_asyncCreatedPromiseList = []
	#_pluginList = []

	// 通过代理执行 会更新timeline等操作
	// 代理可以补充更多的方法 其他插件想要补充 刻在数组后追加  例如抽帧插件 对serializableJson进行的补充
	typeMap = {
		add: {
			card: [this.addCard], // 添加卡片
			ai: [this.addVirtualManClip], // 添加虚拟人
			image: [this.addImageClip], // 添加图片
			video: [this.addVideoClip], // 添加视频
			text: [this.addTextClip], // 添加文字
			background: [this.addBackground], // 添加背景
			transition: [this.addTransition], // 添加过渡
			filter: [this.addFilter], // 添加滤镜
			aiAudio: [this.addAiAudioClip], // 添加数字人音频
			captions: [this.addCaptions], // 添加字幕
			videoTranslateCaptions: [this.addVideoTranslateCaptions] // 添加视频转译字幕
		},
		remove: {
			transition: [this.removeTransition],
			clip: [this.removeClip],
			filter: [this.removeFilter]
		},
		update: {
			positon: [this.updateClipPositon], // todo
			updateClipZindex: [this.updateClipZindex], // 更改卡片index
			destoryVideoEditor: [this.destoryVideoEditor], // 删除编辑器
			updateClipSequence: [this.updateClipSequence], // 更改clip播放时间
			moveLayerForward: [this.moveLayerForward], // 图层上移
			moveLayerBackward: [this.moveLayerBackward], // 图层下移
			moveLayerToTop: [this.moveLayerToTop], // 图层置顶
			moveLayerToBottom: [this.moveLayerToBottom], // 图层置底
			updateClipXY: [this.updateClipXY], // 更新clip x y的值
			updateClipWH: [this.updateClipWH], // 更新宽高
			updateClipAngle: [this.updateClipAngle], // 更新角度
			updateTextFontContent: [this.updateTextFontContent], // 更新文字内容
			updateTextFontPath: [this.updateTextFontPath], // 更新字体
			updateTextFontSize: [this.updateTextFontSize], // 更新文字大小
			updateTextFontColor: [this.updateTextFontColor], // 更新文字颜色
			updateTextAlignType: [this.updateTextAlignType], // 更新文字对齐方式
			updateFilterSequence: [this.updateFilterSequence], // 更新滤镜
			updateAvClipVolume: [this.updateAvClipVolume], // 更新音量
			updateCardDuration: [this.updateCardDuration], // 更新卡片时长
			updateClipScale: [this.updateClipScale], // 更新缩放
			updateCaptionsFontColor: [this.updateCaptionsFontColor], // 更新字幕颜色
			updateCaptionsFontSize: [this.updateCaptionsFontSize], // 更新字幕大小
			updateCaptionsFontPath: [this.updateCaptionsFontPath] // 更新字幕字体
		},
		query: {
			serializableJson: [this.serializableJson]
		},
		seek: {
			seekTime: [this.seek]
		},
		videoCtrl: {
			playSdk: [this.playSdk],
			pauseSdk: [this.pauseSdk]
		}
	}
	editorCanvas = null
	copyObj = null
	constructor(canvasId) {
		if (!canvasId) return
		super()
		if (Editor.#_cache) {
			return Editor.#_cache
		}
		Editor.#_cache = this
		this.#_randerCanvasId = canvasId
		this.defaultBackgroundStoreState = defaultBackgroundStore()
		this.onload = false
	}

	static getEditor() {
		return Editor.#_cache
	}

	init() {
		console.log('加载sdk前！！！！！！！！！！！！！！！！！！！！！！！！！！1')
		this.#_install()
	}

	#_install() {
		if (!window.Module) {
			console.log('创建Module')
			window.Module = {}
		}
		console.log('绑定onRuntimeInitialized')
		window.Module.onRuntimeInitialized = () => {
			console.log('调用onRuntimeInitialized')
			this.onload = true
			this.#_onload()
		}
		// var Module = {}
		// location.reload(true);
		const scriptElement = document.createElement('script')
		console.log(window.location, 'window.location')
		scriptElement.src = './Rendering/OVSWasm.js'
		console.log(scriptElement.src)
		// scriptElement.src = "/yoya/#/Rendering/OVSWasm.js";
		scriptElement.async = true
		document.body.appendChild(scriptElement)
		// scriptElement.onload = () => {
		// 	window.addEventListener('wasmTimelineLoaded', this.#_onload.bind(this))
		// }
	}

	#_onload() {
		console.log('wasmTimelineLoaded  加载sdk成功 ！！！！！！！！！！！！！！！！！！！！！！')
		// 不打印SDK日志
		super.printSdkLog(0)
		console.log('获取sdk版本 ！！！！！！！！！！！！！！！！！！！！！！')
		super.getVersion()
		// 添加背景色
		Promise.all(this.#_asyncCreatedPromiseList).then(() => {
			let width = 1920
			let height = 1080
			if (this.timelineStoreState.templateStyle === 'down') {
				width = 1080
				height = 1920
			}
			console.log('创建sdk画布！！！！！！！！！！！！！！！！！')
			this.createVideoEditor(this.#_randerCanvasId, width, height)
			this.editorCanvas = new EditorCanvas(this) // 加载fabric的canvas
			// 加载各种插件
			this.#_pluginList.forEach(plugin => {
				// 插件可以是构造函数 也可以是实例
				if (typeof plugin === 'function' && typeof plugin.prototype === 'object') {
					const objPlugin = new plugin()
					objPlugin.install(this)
				} else {
					plugin.install(this)
				}
			})

			// 执行loading回调
			this.#_loadCallBackList.forEach(fn => {
				fn.call(this)
			})
			this.#_loadCallBackList = []
			this.#_pluginList = []
		})
	}

	asyncCreated(promise) {
		this.#_asyncCreatedPromiseList.push(promise)
	}

	loaded(fn) {
		this.#_loadCallBackList.push(fn)
	}

	// 代理函数
	executeAsyncFunction(asyncFunc, callback) {
		asyncFunc(result => {
			// 处理异步函数的回调
			callback(result)
		})
	}

	use(plugin) {
		this.#_pluginList.push(plugin)
	}

	getCanvasId() {
		return this.#_randerCanvasId
	}

	getEditorCanvas() {
		return this.editorCanvas.editorFabric
	}

	// 新增
	async add(type, obj = {}, isDrawRect = true) {
		let res
		if (type === 'card') {
			res = this.addCard(obj)
			this.query('serializableJson')
			return res
		}
		if (type !== 'card' && !obj.card_name) {
			// 新增时，先将当前的card_name赋值
			obj.card_name = this.timelineStoreState.getCardName
		}
		obj.clip_name = obj.clip_name ? obj.clip_name : `my_${type}_clip` + '-' + nanoid() // 兜底 没有clip_name时赋值
		if (!obj.zIndex) {
			obj.zIndex = this.timelineStoreState.getActiveClipListZindex + 1
		}
		if (obj.file_path) {
			obj.file_path = obj.file_path.replace(/^http:/, 'https:')
		}
		for (let fn of this.typeMap.add[type]) {
			res = await fn.call(this, obj)
		}
		if (type !== 'background' && type !== 'card' && type !== 'transition' && type !== 'aiAudio') {
			// 不能更改图层的
			this.updateClipZindex({
				clip_name: obj.clip_name,
				zIndex: obj.zIndex
			})
		}

		// 需要添加补充内容的 目前有  锁功能 跟随卡片时长 背景图 音量  多媒体数据原始url
		if (type !== 'card' && type !== 'transition' && type !== 'filter' && type !== 'ai') {
			if (this.timelineStoreState.getCurrentHuman.clip_list) {
				const clip = {
					id: obj.clip_name,
					url: obj.file_path ? obj.file_path : '', // 无法直接给c++的 原始url
					coverImg: obj.coverImg ? obj.coverImg : '', // 背景图
					is_lock: false, // 锁的功能
					isFollowCardDuration: type === 'background', // 跟随卡片
					duration: obj.duration
				}
				// 是否跟随卡片市场
				this.timelineStoreState.getCurrentHuman.clip_list.push(clip)
			}
		}
		this.query('serializableJson') // 添加后 更新timeline
		if (type !== 'card' && type !== 'transition' && isDrawRect !== false) {
			// 除了卡片和过渡外画框
			this.editorCanvas.drawRectByClipName(obj.clip_name)
		}

		const upDuration = {
			duration: obj.duration,
			clip_name: obj.clip_name
		}
		this.timelineStoreState.updataAihuamByClip(upDuration)
		// console.log(obj);
		return res
	}

	// 删除
	remove(type, obj = {}, update = true) {
		const res = this.typeMap.remove[type].forEach(fn => {
			fn.call(this, obj)
		})
		obj.clip_name = obj.clip_name ? obj.clip_name : this.timelineStoreState.getActiveClipName
		if (type == 'clip' && this.timelineStoreState.getCurrentHuman.clip_list) {
			const newClipList = this.timelineStoreState.getCurrentHuman.clip_list.filter(clip => {
				return clip.id !== obj.clip_name
			})
			this.timelineStoreState.getCurrentHuman.clip_list = newClipList
		}
		if (update) {
			this.query('serializableJson')
		}
		return res
	}
	videoCtrl(type, obj = {}) {
		const res = this.typeMap.videoCtrl[type].forEach(fn => {
			fn.call(this, obj)
		})
		return res
	}
	// 更新
	update(type, obj = {}) {
		const res = this.typeMap.update[type].forEach(fn => {
			fn.call(this, obj)
		})
		this.query('serializableJson')
		if (type === 'updateClipSequence') {
			// 更改了时间 重汇一下当前帧
			let renderTime = 0
			this.timelineStoreState.getCardList.forEach((card, index) => {
				if (index < this.timelineStoreState.activeCardIndex) {
					renderTime += card.duration
				}
			})
			renderTime += this.timelineStoreState.timePoint
			this.renderSeek(renderTime)
		}
		return res
	}

	// 查询
	query(type, obj = {}) {
		const res = this.typeMap.query[type].forEach(fn => {
			fn.call(this, obj)
		})
		//  this.setAllCardAuration(this.timelineStoreState.getAihuamByClip.duration)
		return res
	}
	// 1x  11 mk bo6 lo

	// 渲染某一幀
	renderSeek(time, wait = 100) {
		// 防抖
		if (this.renderSeekTimer) {
			clearTimeout(this.renderSeekTimer)
		}
		this.seek(time) // 渲染某一帧 这是相对于整体的时间线
		// 下面是与画框相关
		const editorFabic = this.getEditorCanvas()
		editorFabic.clear()
		this.renderSeekTimer = setTimeout(() => {
			// 清空fabric
			let cardTime = time
			// 算出相对于当前卡片的时间线
			for (const card of this.timelineStoreState.getCardList) {
				if (cardTime >= card.duration) {
					cardTime -= card.duration
				} else {
					break
				}
			}
			const activeList = [] // 活动的clip
			// 算当前帧有哪些 可视clip
			this.timelineStoreState.getActiveClipList.forEach(clip => {
				if (clip.sequnce_in <= cardTime && clip.sequnce_out > cardTime) {
					activeList.push(clip)
				}
			})
			activeList.sort((a, b) => {
				return a.zIndex - b.zIndex
			})
			// 画框
			this.editorCanvas.drawRects(activeList)
		}, wait)
	}
	// 添加虚拟人
	addVirtualManClip(obj) {
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_ai_clip' + '-' + nanoid(),
			res_uuid = 'anchor_' + '-' + nanoid(),
			file_path,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration,
			keepUnique = true
		} = { ...obj }
		if (!card_name) {
			return
		}
		if (!file_path) {
			file_path = this.anchorsListStoreState.getList[0]
				? this.anchorsListStoreState.getList[0].anchorPoseList[0].url
				: 'https://source.wengegroup.com/bucket-ai-anchor/anchor/yongzhou/pose_01.png'
		}
		file_path = file_path.replace(/^http:/, 'https:')
		if (keepUnique) {
			this.keepUniqueClipsOfType(card_name, clip_name)
		}
		super.addVirtualManClip(card_name, clip_name, res_uuid, file_path, sequenceIn, sequenceOut)
		this.updateClipPositon(clip_name)
		return clip_name
	}

	// 添加数字人音频
	async addAiAudioClip(obj) {
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_aiAudio_clip' + '-' + nanoid(),
			file_path,
			sequenceIn,
			sequenceOut
		} = { ...obj }
		if (!card_name || !file_path) {
			return
		}
		console.log(obj, 'obj')
		// 多媒体数据
		// file_path = await this.downloadMedia(file_path, res_uuid)
		// this.keepUniqueClipsOfType(card_name, clip_name)
		super.addAvClip(card_name, clip_name, file_path, sequenceIn, sequenceOut)
	}

	// 添加背景
	addBackground(obj) {
		let {
			type = 'image',
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_background_clip' + '-' + nanoid(),
			res_uuid = 'my_background_clip' + '-' + nanoid(),
			file_path = this.defaultBackgroundStoreState.getImgList[0].url,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!card_name) {
			return
		}
		// 保持背景唯一
		this.keepUniqueClipsOfType(card_name, clip_name)
		// 添加背景
		const addObj = {
			card_name,
			clip_name,
			file_path,
			sequenceIn,
			sequenceOut
		}
		if (type === 'video') {
			this.addAvClip(card_name, clip_name, file_path, sequenceIn, sequenceOut)
		} else {
			this.addImageClip(addObj)
		}
		this.updateClipPositon(clip_name)
		super.updateClipZindex(clip_name, 0)
		return clip_name
	}

	// 图层的逻辑是一层只有一个元素 所以理论上 只有新增的时候会增加 最高图层
	// 图层向下移动一层
	moveLayerBackward(obj) {
		let { clip_name } = { ...obj }
		if (!clip_name) {
			clip_name = this.timelineStoreState.activeClipName
		}
		const clipList = this.getActiveCardLayerList()
		for (let i = 0; i < clipList.length; i++) {
			if (clipList[i].id === clip_name && clipList[i - 1] && clipList[i - 1].zIndex !== 0) {
				this.update('updateClipZindex', {
					clip_name: clipList[i - 1].id,
					zIndex: clipList[i].zIndex
				}) // 下一级图层 移动到当前图层
				this.update('updateClipZindex', {
					clip_name: clipList[i].id,
					zIndex: clipList[i - 1].zIndex
				}) // 当前图层 移动到下一级
				break
			}
		}
	}

	// 图层向上移动一层
	moveLayerForward(obj) {
		let { clip_name } = { ...obj }
		if (!clip_name) {
			clip_name = this.timelineStoreState.activeClipName
		}
		const clipList = this.getActiveCardLayerList()
		for (let i = 0; i < clipList.length; i++) {
			if (clipList[i].id === clip_name && clipList[i + 1]) {
				this.update('updateClipZindex', {
					clip_name: clipList[i + 1].id,
					zIndex: clipList[i].zIndex
				}) // 上层的图层 往下移动一层
				this.update('updateClipZindex', {
					clip_name: clipList[i].id,
					zIndex: clipList[i + 1].zIndex
				}) // 当前图层 往上移动一层
				break
			}
		}
	}

	// 图层置顶
	moveLayerToTop(obj) {
		let { clip_name } = { ...obj }
		if (!clip_name) {
			clip_name = this.timelineStoreState.activeClipName
		}
		const editorFabic = this.getEditorCanvas()
		const clipList = this.getActiveCardLayerList()
		let flag = false // 标记是否有移动
		for (let i = 0; i < clipList.length; i++) {
			// 元素置顶 所有上层元素都向下移动
			if (clipList[i].id === clip_name) {
				flag = true
				this.update('updateClipZindex', {
					clip_name: clipList[i].id,
					zIndex: clipList[clipList.length - 1].zIndex
				})
				continue
			}
			if (flag) {
				this.update('updateClipZindex', {
					clip_name: clipList[i].id,
					zIndex: clipList[i].zIndex - 1
				})
			}
		}
	}

	// 图层置底
	moveLayerToBottom(obj) {
		let { clip_name } = { ...obj }
		if (!clip_name) {
			clip_name = this.timelineStoreState.activeClipName
		}
		const clipList = this.getActiveCardLayerList()
		let flag = false // 标记是否有移动
		for (let i = clipList.length - 1; i > 0; i--) {
			console.log(clipList[i].zIndex, clipList[i].id.split('_')[1])
			if (
				clipList[i].id.split('_')[1] === 'caption' ||
				clipList[i].id.split('_')[1] === 'background'
			)
				continue
			// 元素置底 所有上层元素都向上移动
			if (clipList[i].id === clip_name) {
				flag = true
				this.update('updateClipZindex', { clip_name: clipList[i].id, zIndex: 1 })
				continue
			}
			//
			if (flag) {
				this.update('updateClipZindex', {
					clip_name: clipList[i].id,
					zIndex: clipList[i].zIndex + 1
				})
			}
		}
	}

	// 更改clip层级
	updateClipZindex(obj) {
		let { clip_name, zIndex = 0 } = { ...obj }
		if (!clip_name) return
		super.updateClipZindex(clip_name, zIndex)
		// this.editorCanvas.moveTo(clip_name, zIndex)
	}

	// 更新xy坐标
	updateClipXY(obj) {
		// 需要改farbic 所以放这里
		let { clip_name = this.timelineStoreState.getActiveClipName, x, y } = { ...obj }
		const editorEectObj = this.editorCanvas.getRectFromClipName(clip_name)
		x = x - editorEectObj.lineCoords.tl.x + editorEectObj.left
		y = y - editorEectObj.lineCoords.tl.y + editorEectObj.top
		super.updateClipPositon(clip_name, x, y) // 更新视图
		editorEectObj.set('top', y).setCoords()
		editorEectObj.set('left', x).setCoords()
		const editorFabic = this.getEditorCanvas()
		editorFabic.requestRenderAll()
	}

	// 更新wh坐标
	updateClipWH(obj) {
		let { clip_name = this.timelineStoreState.getActiveClipName, width, height } = { ...obj }
		const editorEectObj = this.editorCanvas.getRectFromClipName(clip_name)
		let scaleX = width / editorEectObj.width
		let scaleY = height / editorEectObj.height
		super.updateClipScale(clip_name, scaleX, scaleY)
		editorEectObj.set('scaleX', scaleX).setCoords()
		editorEectObj.set('scaleY', scaleY).setCoords()
		const editorFabic = this.getEditorCanvas()
		editorFabic.requestRenderAll()
	}

	// 更新旋转角度
	updateClipAngle(obj) {
		let { clip_name = this.timelineStoreState.getActiveClipName, rotateAngle = 0 } = { ...obj }
		super.updateClipRotateAngle(clip_name, rotateAngle)
		const editorEectObj = this.editorCanvas.getRectFromClipName(clip_name)
		editorEectObj.set('angle', rotateAngle).setCoords()
		const editorFabic = this.getEditorCanvas()
		editorFabic.requestRenderAll()
	}

	// 更新文字内容
	updateTextFontContent(obj) {
		let { clip_name, content = '' } = { ...obj }
		if (!clip_name) return
		super.updateTextFontContent(clip_name, content)
		this.editorCanvas.drawRectByClipName(clip_name)
	}

	// 更新字体
	updateTextFontPath(obj) {
		let { clip_name, font_path = '' } = { ...obj }
		if (!clip_name) return
		const bufferUrl = font_path.replace(/^http:/, 'https:')
		super.updateTextFontPath(clip_name, bufferUrl)
		// 因为不同的字体所占的位置不同 需要更新框的大小
		this.editorCanvas.drawRectByClipName(clip_name)
	}

	// 更新文字大小
	updateTextFontSize(obj) {
		let { clip_name, size = 20 } = { ...obj }
		if (!clip_name) return
		super.updateTextFontSize(clip_name, size)
		this.editorCanvas.drawRectByClipName(clip_name)
	}

	// 删除元素及clipRect
	removeClip(obj) {
		let { clip_name = this.timelineStoreState.getActiveClipName } = { ...obj }
		super.removeClip(clip_name)
		this.editorCanvas.removeRectByClipName(clip_name)
	}

	// 更新clip缩放
	updateClipScale(obj) {
		let { clip_name, scaleX = 1, scaleY = 1 } = { ...obj }
		if (!clip_name) return
		super.updateClipScale(clip_name, scaleX, scaleY)
		// const editorEectObj = this.editorCanvas.getRectFromClipName(clip_name)
		// editorEectObj.set('scaleX', scaleX).setCoords();
		// editorEectObj.set('scaleY', scaleY).setCoords();
		// const editorFabic = this.getEditorCanvas()
		// editorFabic.requestRenderAll();
	}

	// 获取当前活动卡片的图层
	getActiveCardLayerList() {
		return this.timelineStoreState.getActiveClipList.sort((a, b) => a.zIndex - b.zIndex)
	}

	// 获取当前活动元素的坐标 有空参考pina源码 改成响应式
	listenActiveClip(fn) {
		this.editorCanvas.listenActiveClipList.push(fn)
	}

	copy(clip_name) {
		if (!clip_name) {
			clip_name = this.timelineStoreState.getActiveClipName
		}
		let aiHumanObj

		this.timelineStoreState.getCurrentHuman.clip_list.forEach(clip => {
			if (clip.id === clip_name) {
				aiHumanObj = clip
			}
		})

		this.copyObj = {
			renderObj: this.timelineStoreState.getActiveClipList.find(d => d.id === clip_name),
			rectObj: this.editorCanvas.getRectFromClipName(clip_name),
			aiHumanObj
		}
	}

	// 粘贴
	paste() {
		const rectObj = this.copyObj.rectObj
		const renderObj = JSON.parse(JSON.stringify(this.copyObj.renderObj))
		const aiHumanObj = this.copyObj.aiHumanObj
		let clip_name = renderObj.id
		const clipType = clip_name.split('_')[1]
		const newCLip_name = `my_${clipType}_clip` + '-' + nanoid()
		renderObj.clip_name = newCLip_name
		delete renderObj.id
		delete renderObj.res_uuid
		if (clipType === 'image') {
			renderObj.file_path = renderObj.res_path
			this.add('image', renderObj)
		} else if (clipType === 'text') {
			this.add('text', renderObj)
		} else if (clipType === 'video') {
			renderObj.file_path = renderObj.res_path
			renderObj.coverImg = aiHumanObj.coverImg
			this.add('video', renderObj)
		}

		// 因为此时可能还没有render 更不可能有rect框 所以执行更新render 不需要更新rect框
		// 查找当前赋值的元素在不在 在的话横纵加40 不在的话 保持原位置
		let x = rectObj.left
		let y = rectObj.top
		let { rotate_angle, scale_x, scale_y } = { ...renderObj }
		// 更新位置
		if (this.timelineStoreState.getActiveClipList.find(d => d.id === clip_name)) {
			super.updateClipPositon(newCLip_name, x + 40, y + 40)
		} else {
			super.updateClipPositon(newCLip_name, x, y)
		}
		// 更新角度
		super.updateClipRotateAngle(newCLip_name, rotate_angle)
		// 更新缩放
		super.updateClipScale(newCLip_name, scale_x, scale_y)
	}

	// json生成编辑器
	parseJson(json, time) {
		if (!time) {
			time = this.timelineStoreState.getTimePoint ? this.timelineStoreState.getTimePoint : 0
		}
		this.renderSeek(time, 0)
		super.parseJson(json)
		this.query('serializableJson')
	}

	// 添加时保持同类型唯一 功能是找到所有相同类型的clip，然后删除
	keepUniqueClipsOfType(card_name, clip_name) {
		const cardList = this.timelineStoreState.getCardList
		const card = cardList.find(item => item.id === card_name)
		const clipList = card.track_list[0].clip_list
		if (!clipList || !clip_name) return
		const type = clip_name.split('_')[1]
		clipList.forEach(item => {
			const itemType = item.id.split('_')[1]
			if (itemType === type) {
				this.remove('clip', { clip_name: item.id })
			}
		})
	}

	// 删除卡片
	removeCard(obj, cache = false) {
		let { card_name } = { ...obj }
		super.removeCard(card_name)
		// 删除转场
		// if(this.timelineStoreState.getTransitionList && this.timelineStoreState.getTransitionList.length > 0){
		//   const findItem  = this.timelineStoreState.getTransitionList.find((item) => {
		//     return card_name === item.a_card_id;
		//   });
		//   if(findItem){
		//     this.removeTransition({transition_name: findItem.id});
		//   }
		// }
		// if(!cache){
		//   this.timelineStoreState.aiHumans.splice(
		//     this.timelineStoreState.aiHumans.findIndex((item) => item.card_id === card_name),
		//     1
		//   );
		//   this.query('serializableJson')
		// }
	}
}
